import React from "react";
import { AlertTriangle, RefreshCw, Home } from "lucide-react";

function Fallback({ error, onRetry }) {
  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ backgroundColor: "#0C1924" }}>
      <div className="max-w-md w-full text-center rounded-2xl border p-8" style={{ borderColor: "#3A5463", backgroundColor: "rgba(25,52,71,0.6)" }}>
        <div className="inline-flex p-3 rounded-xl mb-4" style={{ backgroundColor: "rgba(211,164,111,0.15)" }}>
          <AlertTriangle className="h-8 w-8" style={{ color: "#D3A46F" }} />
        </div>
        <h1 className="font-heading text-2xl font-bold" style={{ color: "#F4F7FA" }}>Algo não carregou como esperado</h1>
        <p className="text-sm mt-2" style={{ color: "#B8C5D0" }}>
          Ocorreu um erro ao abrir esta tela. Você pode tentar novamente sem recarregar a página.
        </p>
        {error?.message && (
          <p className="text-xs mt-3 font-mono px-3 py-2 rounded-lg break-words" style={{ color: "#8296A3", backgroundColor: "rgba(12,25,36,0.6)" }} data-testid="error-boundary-message">
            {String(error.message)}
          </p>
        )}
        <div className="flex items-center justify-center gap-3 mt-6">
          <button onClick={onRetry} data-testid="error-retry-btn" className="metron-gradient-btn text-white font-semibold rounded-xl h-11 px-5 flex items-center gap-2">
            <RefreshCw className="h-4 w-4" /> Tentar novamente
          </button>
          <a href="/" data-testid="error-home-btn" className="rounded-xl h-11 px-5 flex items-center gap-2 font-medium border" style={{ borderColor: "#3A5463", color: "#F4F7FA" }}>
            <Home className="h-4 w-4" /> Início
          </a>
        </div>
      </div>
    </div>
  );
}

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, key: props.resetKey };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  static getDerivedStateFromProps(props, state) {
    // Reseta o boundary sempre que a rota muda, recuperando sem refresh manual.
    if (props.resetKey !== state.key) {
      return { key: props.resetKey, hasError: false, error: null };
    }
    return null;
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return <Fallback error={this.state.error} onRetry={() => this.setState({ hasError: false, error: null })} />;
    }
    return this.props.children;
  }
}
